/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {DbFactory} from '../../engine/db/factory/dbFactory';
import {HistoryInput} from './history-input';
import {ObjectFactory} from '../../engine/http/factory/object-factory';

export class HistoryInputFactory implements DbFactory<HistoryInput> {
  /**
   * id property of stored items
   */
  public idField: string;

  /**
   * label property of stored items
   */
  public labelField: string[];

  constructor(idField?: string, labelField?: string[]) {
    this.idField = idField ?? 'id';
    this.labelField = labelField ?? ['label'];
  }

  convertSerial(o: any): HistoryInput {
    const historyInput = new HistoryInput();
    const factory = new ObjectFactory('', this.idField, this.labelField);
    historyInput.setId(o.id);
    if (o.lastResults.length > 0) {
      o.lastResults.forEach(lr => {
        historyInput.lastResults.push(factory.build(lr));
      });
    }
    return historyInput;
  }

  getStorageName(): string {
    return 'search-history';
  }
}
